import createReducer from 'admin/reducers/createReducer'

const INITIAL_REQUEST_STATE = {}

export default baseType =>
  createReducer(INITIAL_REQUEST_STATE, {
    [baseType]: state => ({...state, fetching: true, fetched: false}),
    [`${baseType}_REJECTED`]: state => ({...state, fetching: false, fetched: true}),
    [`${baseType}_FULFILLED`]: state => ({...state, fetching: false, fetched: true}),
    [`CLEAR_${baseType}`]: () => INITIAL_REQUEST_STATE
  })
